import { render, staticRenderFns } from "./ViewCandidate.vue?vue&type=template&id=cb7d4d42"
import script from "./ViewCandidate.vue?vue&type=script&lang=js"
export * from "./ViewCandidate.vue?vue&type=script&lang=js"
import style0 from "./ViewCandidate.vue?vue&type=style&index=0&id=cb7d4d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports